// extracted by mini-css-extract-plugin
module.exports =  {"tc-faceted-toolbar":"FacetedToolbar-module__tc-faceted-toolbar___NpCxO","tc-faceted-switch-mode":"FacetedToolbar-module__tc-faceted-switch-mode___poz3i"};